import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Typography } from "@mui/material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import moment from "moment";
import { getNotification } from "../../api/notificationApi";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import LoadingSpinner from "../../common/components/LoadingSpinner";

const Notification = () => {
    const dispatch = useDispatch();
    const { loading, user } = useSelector((state) => state.auth);
    const [notificationData, setNotificationData] = useState([]);

    const getNotificationData = async () => {
        try {
            dispatch(setLoading({ loading: true }));
            const startDate = new Date();

            // Get datetime 24 hours from now
            const endDate = new Date(startDate);
            endDate.setHours(startDate.getHours() + 24);

            // Format dates to ISO string
            const startDateISO = startDate.toISOString();
            const endDateISO = endDate.toISOString();

            const response = await getNotification(user?.user_id, 1, 'DCP_REMINDER', moment(startDateISO).format('YYYY-MM-DD'), moment(endDateISO).format('YYYY-MM-DD'));
            const newData = response.data.data || [];
            setNotificationData(newData);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getNotificationData();
    }, []);

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonCard
                borderRadius={2}
                border={`1px solid ${theme.palette.background.secondary}`}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>My DCP Notifications</Typography>
                                <Typography fontSize={13} color={theme.palette.background.dark}>Important notifications to help you stay on track.</Typography>
                            </Box>
                            <CommonButton
                                label="Last 24 hours"
                                marginBottom="0px"
                                width="150px"
                                height="30px"
                                background={theme.palette.background.main}
                                color={theme.palette.background.dark}
                                borderRadius={3}
                            />
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    notificationData?.length > 0 ?
                        (<Box
                            sx={{
                                height: '30vh',
                                overflow: 'auto'
                            }}
                        >
                            {notificationData.map((a, index) => {
                                return (
                                    <Fragment key={index}>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            padding="10px"
                                        >
                                            <Box sx={{ width: '80%' }}>
                                                <Typography fontSize={15} fontWeight="600">{a.title}</Typography>
                                            </Box>
                                            <Typography
                                                fontSize={14}
                                                color={theme.palette.background.dark}
                                                sx={{ whiteSpace: 'nowrap' }}
                                            >
                                                {moment(a.published_at).fromNow()}
                                            </Typography>
                                        </Box>
                                    </Fragment>
                                )
                            })}
                        </Box>) : (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 0.8 }}>
                                <Typography>No Data Found</Typography>
                            </Box>
                        )
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default Notification;